if (!customElements.get('video-hero-section')) {
    class VideoHeroSection extends HTMLElement {
        connectedCallback() {
            this.trigger = this.querySelector('[data-video-trigger]')
            this.video = this.querySelector('[data-inline-video]')
            this.playBtn = this.querySelector('.play-btn')
            this.soundToggle = this.querySelector('.sound-toggle')
            this.progressFill = this.querySelector('.video-progress-fill')

            this.modal = this.querySelector('[data-video-modal]')
            this.modalVideo = this.querySelector('[data-modal-video]')
            this.closeBtn = this.querySelector('[data-close-modal]')

            if (!this.video || !this.trigger) return

            this.isMuted = this.video.hasAttribute('muted')
            this.video.muted = this.isMuted

            this.bindEvents()
        }

        isMobile() {
            return window.innerWidth < 1024
        }

        bindEvents() {
            const togglePlay = (e) => {
                e.stopPropagation()
                if (this.isMobile()) return

                this.video.paused || this.video.ended
                    ? this.video.play()
                    : this.video.pause()
            }

            const toggleMute = (e) => {
                e.stopPropagation()
                if (this.isMobile()) return

                this.isMuted = !this.isMuted
                this.video.muted = this.isMuted
                this.soundToggle?.classList.toggle('mute', this.isMuted)
            }

            this.trigger.addEventListener('click', (e) => {
                if (this.isMobile()) {
                    e.preventDefault()
                    this.openModal()
                } else {
                    togglePlay(e)
                }
            })

            this.playBtn?.addEventListener('click', togglePlay)
            this.soundToggle?.addEventListener('click', toggleMute)

            this.video.addEventListener('play', () => {
                if (!this.isMobile()) this.classList.add('playing')
            })

            this.video.addEventListener('pause', () => {
                if (!this.video.ended) this.classList.remove('playing')
            })

            this.video.addEventListener('ended', () => {
                this.classList.remove('playing')
                this.resetProgress()
            })

            this.video.addEventListener('timeupdate', () => {
                if (!this.video.duration || !this.progressFill) return
                const progress =
                    (this.video.currentTime / this.video.duration) * 100
                this.progressFill.style.width = `${progress}%`
            })

            this.closeBtn?.addEventListener('click', () => this.closeModal())

            this.modal?.addEventListener('click', (e) => {
                if (e.target === this.modal) this.closeModal()
            })

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.isModalOpen()) {
                    this.closeModal()
                }
            })
        }

        resetProgress() {
            if (this.progressFill) {
                this.progressFill.style.width = '0%'
            }
        }


        openModal() {
            if (!this.modal || !this.modalVideo) return

            this.video.pause()

            this.modal.classList.replace('hidden', 'flex')
            document.body.style.overflow = 'hidden'

            this.modalVideo.currentTime = 0
            this.modalVideo.play().catch(() => { })
        }

        closeModal() {
            this.modal.classList.replace('flex', 'hidden')
            document.body.style.overflow = ''

            this.modalVideo.pause()
            this.modalVideo.currentTime = 0
        }

        isModalOpen() {
            return this.modal?.classList.contains('flex')
        }
    }

    customElements.define('video-hero-section', VideoHeroSection)
}